jQuery(function ($) {

  	// Add smooth scroll to anchor links. Just add the "smooths" class to your links
	$('li.smooth a[href*="#"]:not([href="#"])').click(function () {
		if (
			location.pathname.replace(/^\//, "") ==
			this.pathname.replace(/^\//, "") &&
			location.hostname == this.hostname
		) {
			var target = $(this.hash);
			target = target.length
				? target
				: $("[name=" + this.hash.slice(1) + "]");
			if (target.length) {
				$("html,body").animate(
					{
						scrollTop: target.offset().top,
					},
					500
				);
				return false;
			}
		}
	});


  // Navbar Submenu Dropdown Links Click - Mobile
  $(".menu-toggle").on("click", function (e) {
    $(this).toggleClass("collapsed");

    var $subMenu = $(this).parent().next(".sub-menu");
    $subMenu.toggleClass("slideInUp animated show");

    return false;
  });

  // Navbar Toggler
  $(".nav-toggler").on("click", function (e) {
    $(".nav-search-icon").removeClass("nav-search-icon--close");
    $("#search-box").css("display", "none");
    $(this).toggleClass("is-active");
    $("div.nav-collapse").toggleClass("show");
  });

  // Menu Search Trigger
  $(".nav-search-icon").click(function (e) {
    e.stopPropagation();
    e.preventDefault();
    $(".nav-toggler").removeClass("is-active");
    $(".nav-collapse").removeClass("show");
    $(this).toggleClass("nav-search-icon--close");
    $("#search-box").fadeToggle(350);
    $("#search-box .header-search-input").focus();
  });

  // Back To Top Button
  $(window).scroll(function () {
    if ($(this).scrollTop() > 200) {
      $(".backtotop").fadeIn();
    } else {
      $(".backtotop").fadeOut();
    }
  });

  $(".backtotop").click(function () {
    $("html, body").animate({ scrollTop: 0 }, 600);
    return false;
  });

  // GSAP
  // gsap.from(".nav-logo", {
  //   duration: 1,
  //   x: -100,
  //   opacity: 0,
  //   ease: "bounce",
  // });


  gsap.from("#services .columns .col", {
    scrollTrigger: "#services .columns",
    duration: 0.75,
    y: 200,
    opacity: 1,
    ease: "slow",
    stagger: 0.15,
  });

  gsap.from(".skills-icons-grid div", {
    scrollTrigger: ".skills-icons-grid",
    duration: 0.5,
    y: 100,
    opacity: 0,
    ease: "slow",
    stagger: 0.15,
  });


  gsap.from("#recent-work .columns", {
    scrollTrigger: "#recent-work",
    duration: 0.5,
    y: 200,
    opacity: 0,
    ease: "slow",
    stagger: 0.15,
  });

});
